import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { imagesDir } from 'src/app/global.config';
import { DateInterval } from 'src/app/shared/model';
import { DataManagementService, GroupDto } from '../../data-management';
import { FuelingClassification  } from '../../parc-management';
import {  TravelReport } from '../../parc-management';
import { ActivityVehiculeClassification, VehiculeClassification } from './activity-vehicule-classifications.model';
import { ActivityVehiculeClassificationsService } from './activity-vehicule-classifications.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

export interface DriverScore {
  matricule: string;
  driver: string;
  avatarUri?: string;
  score: number;
}

@Component({
  selector: 'app-activity-vehicle-classification',
  templateUrl: './activity-vehicle-classification.component.html',
  styleUrls: ['./activity-vehicle-classification.component.css']
})
export class ActivityVehicleClassificationComponent implements OnInit {

  imagesDir = imagesDir;

  loadingGroup = false;
  loadingSettings = false;
  loadingActivity = false;
  loadingFueling = false;
  loadingTurnOver = false;
  loadingSinistre = false;
  loadingOffense = false;

  dateInterval: DateInterval = new DateInterval();

  now: Date = new Date();

  startDate: Date = new Date();
  endDate: Date = new Date();

  /** GROUP VAR */
  selectedGroup: GroupDto = new GroupDto();

  groups: GroupDto[] = [];

  // best 5 drivers lists  
  driverScores: DriverScore[]=[];

  // chart lists
  activities: TravelReport[] = [];
  distanceDriven: TravelReport[] = [];
  pathTime: TravelReport[] = [];
  fuelings: FuelingClassification[] = [];
  offenses: VehiculeClassification[] = [];
  sinistres: VehiculeClassification[] = [];
  turnOvers: VehiculeClassification[] = [];

  /** classification settings */
  classification: ActivityVehiculeClassification = new ActivityVehiculeClassification();
  @ViewChild('classificationModal', { static: false })
  classificationModal: ModalDirective;

  constructor(private classificationService: ActivityVehiculeClassificationsService, private groupService: DataManagementService,
    public toastr: ToastrService) { }

  ngOnInit() {
    this.endDate.setDate(new Date().getDate());
    this.startDate = new Date();
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 59);
    this.loadGroups();

  }

  loadGroups() {
    this.loadingGroup = true;
    this.groupService.getAllGroups().subscribe(groups => {
      this.groups = groups;
      if (this.groups.length > 0) {
        this.selectedGroup = this.groups[0];
        this.loadCoefficientSetting();

      }
      this.loadingGroup = false;
    }, err => {
      this.loadingGroup = false;
      this.toastr.error("Erreur lors de chargements", "Group");
    })
  }

  onGroupChange() {
    const groupsIds = this.classification.groups.map(g => g.idGroupe);
    if(!groupsIds.includes(this.selectedGroup.idGroupe)){
      this.classification = new ActivityVehiculeClassification();
      this.driverScores = [];
      this.loadCoefficientSetting();
    }
    else {
      this.loadAllClasifications();
    }
  }

  loadOffenseClassification() {
    this.loadingOffense = true;
    this.offenses = [];
    this.classificationService.getVehicleLossesClassificationsByGroupId('offense', this.selectedGroup.idGroupe, this.dateInterval)
      .subscribe(offenses => {
        this.offenses = offenses;
        this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
        this.loadingOffense = false;
      }, err => {
        this.loadingOffense = false;
        this.toastr.error("Erreur lors de chargements", "Classification Offense");
      }
      )
  }

  loadSinistreClassification() {
    this.loadingSinistre = true;
    this.sinistres = [];
    this.classificationService.getVehicleLossesClassificationsByGroupId('sinistre', this.selectedGroup.idGroupe, this.dateInterval)
      .subscribe(sinistres => {
        this.sinistres = sinistres;
        this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
        this.loadingSinistre = false;
      }, err => {
        this.loadingSinistre = false;
        this.toastr.error("Erreur lors de chargements", "Classification sinistre");
      }
      )
  }

  loadTurnOverClassification() {
    this.loadingTurnOver = true;
    this.turnOvers = [];
    this.classificationService.getVehicleTurnOverClassificationsByGroupId(this.selectedGroup.idGroupe, this.dateInterval)
      .subscribe(turnOvers => {
        this.turnOvers = turnOvers;
        this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
        this.loadingTurnOver = false;
      }, err => {
        this.loadingTurnOver = false;
        this.toastr.error("Erreur lors de chargements", "Classification Charge conducteur");
      }
      )
  }

  loadCoefficientSetting() {
    this.loadingSettings = true;
    this.classificationService.getCoefficicientSettingsByGroupId(this.selectedGroup.idGroupe).subscribe(classification => {
      if (classification) {
        this.classification = classification;
        this.loadAllClasifications();
      }
      this.loadingSettings = false;
    }, err => {
      this.loadingSettings = false;
      this.toastr.error("Erreur lors de chargements", "Coefficient");
    })
  }

  loadFuelingClassification() {
    this.loadingFueling = true;
    this.fuelings = [];
    this.classificationService.getVehicleFuelingClassificationByTransportTypeId(this.selectedGroup.idGroupe, this.dateInterval, '')
      .subscribe(fuelings => {
        this.fuelings = fuelings.sort((a, b) => (a.cost > b.cost) ? -1 : 1);
        this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
        this.loadingFueling = false;
      }, err => {
        this.loadingFueling = false;
        this.toastr.error("Erreur lors de chargements", "Classification Carburant");
      }
      )
  }

  loadClassification() {
    this.loadingActivity = true;
    this.activities = [];
    this.distanceDriven = [];
    this.pathTime = [];
    this.classificationService.getVehicleActivityClassificationByTransportTypeIdOrGroupId(this.selectedGroup.idGroupe, this.dateInterval, null)
      .subscribe(activities => {
        if (activities.length > 0) {
          if (this.classification?.hActivity) {
            this.activities = activities.slice().sort((a, b) => (a.pathDuration > b.pathDuration) ? -1 : 1);
            this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
          }
          if (this.classification?.mileage) {
            this.distanceDriven = activities.slice().sort((a: { distanceDriven: number }, b: { distanceDriven: number }) => (a.distanceDriven > b.distanceDriven) ? -1 : 1);
            this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
          }
          if (this.classification?.workingTime) {
            this.pathTime = activities.slice().sort((a: { pathTime: number }, b: { pathTime: number }) => (a.pathTime > b.pathTime) ? -1 : 1);
            this.driverScores = this.classificationService.computeDriverScores(this.distanceDriven,this.fuelings,this.sinistres,this.turnOvers,this.offenses,this.activities,this.pathTime,this.classification)
          }
        }
        this.loadingActivity = false;
      }, () => {
        this.loadingActivity = false;
        this.toastr.error("Erreur lors de chargements", "Classification");
      });

  }

  loadAllClasifications() {
    this.dateInterval.startDate = this.startDate;
    this.dateInterval.endDate = this.endDate;
    this.dateInterval.startDate.setHours(0, 0, 0, 0);
    this.dateInterval.endDate.setHours(23, 59, 59, 59);
    this.driverScores = [];
    if (this.classification.mileage || this.classification.hActivity || this.classification.workingTime)
      this.loadClassification();
    if (this.classification.fueling)
      this.loadFuelingClassification();
    if (this.classification.offense)
      this.loadOffenseClassification();
    if (this.classification.sinistre)
      this.loadSinistreClassification();
    if (this.classification.turnover)
      this.loadTurnOverClassification();
  }

  classificationWasSaved(classification: ActivityVehiculeClassification) {
    if (classification.groups.find(g => g.idGroupe == this.selectedGroup.idGroupe)) {
      this.classification = classification;
      this.loadAllClasifications();
    } else {
      this.classification = new ActivityVehiculeClassification();
      this.driverScores = [];
    }
    this.classificationModal.hide();
  }

  isAllLoading(){
    return this.loadingActivity || this.loadingFueling || this.loadingTurnOver || this.loadingSinistre || this.loadingOffense;
  }
}
